import React, { useState, useEffect } from 'react';
import {
  Button,
  Label,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from 'reactstrap';

// Comment sections options
const COMMENT_SECTIONS = [
  { value: 'car_inspection', label: 'Inspección de carroceria' },
  { value: 'accesories_inventory', label: 'Accesories e Inventario' },
  { value: 'mechanic_state', label: 'Estado mecánico' },
  { value: 'security', label: 'Seguridad' },
];

/**
 * Modal to create or edit a comment value and section
 */
function CommentModal({
  title = 'Comentario',
  isOpen = false,
  onToggle = () => {},
  defaultValue = '',
  defaultSection = '',
  onSubmit = () => {},
}) {
  const [value, setValue] = useState(defaultValue || '');
  const [section, setSection] = useState(defaultSection || '');

  // Update values when props change (for edit mode)
  useEffect(() => {
    setValue(defaultValue || '');
    setSection(defaultSection || '');
  }, [defaultValue, defaultSection]);

  const handleSubmit = () => {
    if (!value.trim() || !section) return;
    onSubmit(value.trim(), section);
    onToggle(); // Close modal after submit
  };

  const handleCancel = () => {
    setValue(defaultValue || ''); // Reset to original value
    setSection(defaultSection || ''); // Reset to original section
    onToggle(); // Close modal
  };

  return (
    <Modal isOpen={isOpen} fade={false} toggle={onToggle}>
      <ModalHeader toggle={onToggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label htmlFor="commentSection">Sección</Label>
          <Input
            id="commentSection"
            type="select"
            value={section}
            onChange={(e) => setSection(e.target.value)}
          >
            <option value="">Seleccione una sección</option>
            {COMMENT_SECTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label htmlFor="commentValue">Valor del comentario</Label>
          <Input
            id="commentValue"
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Ej: Comentario de ejemplo"
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSubmit();
              }
            }}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={handleSubmit}>
          Guardar
        </Button>
        <Button color="secondary" onClick={handleCancel}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default CommentModal;
